// extracted by mini-css-extract-plugin
export default {"pie-chart-segment":"FAniR"};